import { memo } from 'react';

function GaugeSkeleton() {
  return (
    <svg width="113" height="104" viewBox="0 0 113 104" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_di_6244_38000)">
        <rect x="20" y="12" width="80.8421" height="64" rx="6" fill="white" />
      </g>
      <g filter="url(#filter1_i_6244_38000)">
        <rect x="31.79" y="20.4209" width="15.1579" height="16.8421" rx="3" fill="#DFE3E8" />
      </g>
      <rect opacity="0.8" x="54.1846" y="22.6045" width="19.2105" height="4.05263" rx="1.5" fill="#919EAB" stroke="#919EAB" />
      <rect opacity="0.8" x="54.1846" y="32.71" width="34.3684" height="4.05263" rx="1.5" fill="#919EAB" stroke="#919EAB" />
      <rect opacity="0.24" x="32.29" y="44.499" width="56.2632" height="4.05263" rx="1.5" fill="#919EAB" stroke="#919EAB" />
      <rect opacity="0.24" x="32.29" y="54.6045" width="56.2632" height="4.05263" rx="1.5" fill="#919EAB" stroke="#919EAB" />
      <defs>
        <filter id="filter0_di_6244_38000" x="-8" y="0" width="120.842" height="104" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="-8" dy="8" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6244_38000" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6244_38000" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="1" dy="-3" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_6244_38000" />
        </filter>
        <filter
          id="filter1_i_6244_38000"
          x="31.79"
          y="19.4209"
          width="15.1579"
          height="17.8418"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6244_38000" />
        </filter>
      </defs>
    </svg>
  );
}

export default memo(GaugeSkeleton);
